export function unpascal(value?: any) {
  if (value === undefined) {
    return '-'
  }

  const regex = /(?<=[A-Z])(?=[A-Z][a-z])|(?<=[^A-Z])(?=[A-Z])|(?<=[A-Za-z])(?=[^A-Za-z])/g
  const result = value.replace(regex, ' ')
  const lowered = result.toLowerCase()

  return lowered.charAt(0).toUpperCase() + lowered.slice(1)
}
